import { Portfolio } from '@klp/portfolio/classes/Portfolio';
import { Region } from '@klp/portfolio/classes/Region';

export interface IAggregateRequest {
    from: string;
    to: string;
    region?: string;
    forvalter?: string;
    byggNummer?: string;
    filterByKl?: boolean;
    filtrerPaaFavoritter?: boolean;
}

export class AggregateRequest {
    public fromDate?: IAggregateRequest['from'];
    public toDate?: IAggregateRequest['to'];
    public region?: IAggregateRequest['region'] = '';
    public forvalter?: IAggregateRequest['forvalter'] = '';
    public byggNummer?: IAggregateRequest['byggNummer'] = '';
    public filterByKl?: IAggregateRequest['filterByKl'] = true;
    public filtrerPaaFavoritter?: IAggregateRequest['filtrerPaaFavoritter'] = true;

    public constructor(params: IAggregateRequest) {
        Object.assign(this, params);

        if (params && params.region === Region.emptyId) {
            this.region = '';
        }

        if (params && params.forvalter === Portfolio.emptyId) {
            this.forvalter = '';
        }

        if (params && params.byggNummer === '') {
            this.byggNummer = '';
        }
    }
}
